import { render, staticRenderFns } from "./account-details.vue?vue&type=template&id=b97d0888"
import script from "./account-details.vue?vue&type=script&lang=js"
export * from "./account-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports